import { DatePipe } from '@angular/common';
import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    OnInit,
    ViewChild,
} from '@angular/core';
import {
    FormBuilder,
    FormControl,
    FormGroup,
    Validators,
} from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { HomeService } from 'src/app/services/home.service';
import { IndexDBService } from 'src/app/services/indexd-db/indexd-db.service';
import { APIService } from 'src/app/services/integracion/api.service';
import { SeguridadService } from 'src/app/services/seguridad.service';
import { environment } from 'src/environments/environment';
import { Global } from 'src/global';
import { ProcesoReporte } from '../base/proceso-reporte';
import { CajaService } from 'src/app/services/administracion/caja.service';
import { ArqueoCaja } from 'src/app/models/cobranza/arqueo-caja.model';
import { ArqueoCajaService } from 'src/app/services/cobranza/arqueo-caja.service';
import { Router } from '@angular/router';
import { SucursalService } from 'src/app/services/administracion/sucursal.service';
import { Caja } from 'src/app/models/administracion/caja.model';
import { EmpresaService } from 'src/app/services/administracion/empresa.service';
import { CobroService } from 'src/app/services/cobranza/cobro.service';
import { Cobro } from 'src/app/models/cobranza/cobro.model';
import { HttpStatusCode } from '@angular/common/http';

@Component({
    selector: 'app-portal-pagos',
    templateUrl: './portal-pagos.component.html',
    styleUrl: './portal-pagos.component.scss',
})
export class PortalPagosComponent
    extends ProcesoReporte
    implements OnInit, AfterViewInit
{
    habilitado: boolean;
    bloqueado: boolean;
    loadingServicio: boolean;
    loadingPagoServicio: boolean;
    comercios: Record<string, any>[];
    servicios: Record<string, any>[];
    comerciosFiltrados: Record<string, any>[];
    urlImage = `${environment.host}/get_file`;
    buscar: string;
    // formGroup: FormGroup;
    fgCobro: FormGroup | null;
    comercioSeleccionado: Record<string, any> | null;
    servicioSeleccionado: Record<string, any> | null;
    detalleServicioSeleccionado: Record<string, any>[] | null;
    showModalServicio: boolean;
    showModalServicioPago: boolean;
    showBtns: boolean;
    campos: Record<string, any>[];
    camposAdicionales: Record<string, any>[];
    mostrarCamposAdicionales: boolean = false;
    CONSULTA = Global.TRXS.consulta;
    CODIGO_BARRA = Global.TRXS.codigo_barra;

    @ViewChild('vcBuscar', { static: true }) vcBuscar: any;
    saldoInicial: number;
    registroDelDia: Record<string, any>;
    cierre: boolean;
    aperturar: boolean;
    showImporteApertura: boolean;
    cierreDeCaja: boolean;
    cajas: Record<string, any>[];
    caja: Record<string, any> | null;
    totalCobrado: number;
    cantidadCobro: number;
    showPrintArqueo: boolean;
    showPrintCobro: boolean;
    sucursalObj: Record<string, any>;
    nro_transaccion: string;
    fecha_cierre: Date;
    fecha_impresion: Date;
    objArqueo: Record<string, any>;
    objCobro: Record<string, any>;
    tipoImpresoraBluetooth: boolean;
    iniciandoPortal: boolean = false;
    executingProcess: boolean = false;

    constructor(
        private homeService: HomeService,
        private apiService: APIService,
        private messageService: MessageService,
        private seguridadService: SeguridadService,
        private fb: FormBuilder,
        private indexDBService: IndexDBService,
        private datePipe: DatePipe,
        private cajaService: CajaService,
        private cdr: ChangeDetectorRef,
        private arqueoService: ArqueoCajaService,
        private confirmationService: ConfirmationService,
        private router: Router,
        private sucursalService: SucursalService,
        private empresaService: EmpresaService,
        private cobroService: CobroService
    ) {
        super();
        this.createForm();
        this.cajas = [];
        this.comercios = [];
        this.servicios = [];
        this.comerciosFiltrados = [];
        this.detalleServicioSeleccionado = [];
        this.campos = [];
        this.camposAdicionales = [];
        this.comercioSeleccionado = {};
        this.servicioSeleccionado = {};
        this.registroDelDia = {};
        this.caja = {};
        this.fecha_cierre = new Date();
        this.fecha_impresion = new Date();
        this.saldoInicial = 0;
        this.totalCobrado = 0;
        this.cantidadCobro = 0;
        this.loadingServicio = false;
        this.loadingPagoServicio = false;
        this.showModalServicio = false;
        this.showModalServicioPago = false;
        this.showBtns = false;
        this.cierre = false;
        this.showPrintArqueo = false;
        this.showPrintCobro = false;
        this.tipoImpresoraBluetooth = false;
        this.bloqueado = false;
        this.aperturar = false;
        this.habilitado = false;
    }

    ngOnInit(): void {
        this.iniciarPortalDePagos();
    }

    ngAfterViewInit(): void {
        // this.vcBuscar.nativeElement.focus();
    }

    getUrlImage(comercio: Record<string, any>) {
        const tipo = `comercios:${String(comercio.codigo_entidad).trim()}`;
        const url = `${this.urlImage}/${tipo}/${comercio.imagen}`;
        return url;
    }

    async createForm() {
        this.formGroup = this.fb.group({
            buscar: null,
        });
    }

    async iniciarPortalDePagos() {
        try {
            this.iniciandoPortal = true;
            await this.verificarBloqueo();
            await this.controlarBloqueo();
            if (!this.bloqueado) {
                await this.indexDBService.openDatabase();
                await this.verificarCajaBDWeb();
                await this.controlDeArqueoDeCaja();
                await this.cargarSucursalDelUsuario();
                await this.cargarComercios();
            }
            this.iniciandoPortal = false;
        } catch (error: any) {
            if (error?.status === HttpStatusCode.Unauthorized) {
                this.messageService.add({
                    severity: 'error',
                    summary: Global.MESSAGE_SESSION_EXPIRED,
                    detail: Global.MESSAGE_REDIRECT,
                });
                setTimeout(() => {
                    this.router.navigate(Global.LOGIN), 3000;
                });
            }
            this.messageService.add({
                severity: 'error',
                summary: 'Error al iniciar el portal de Pagos',
                detail: error?.message,
            });
            this.iniciandoPortal = false;
        }
    }

    private async verificarBloqueo() {
        const filtros: Record<string, any> = {
            id_empresa: this.currentUser.empresa.id,
        };
        const resp = await this.empresaService.verificarBloqueo(filtros);
        if (!resp.ok) {
            throw new Error(resp.resp);
        }
    }

    async controlarBloqueo() {
        const filtros: Record<string, any> = {
            id_empresa: this.currentUser.empresa.id,
        };
        let resp = await this.empresaService.controlarBloqueo(filtros);
        if (!resp.ok) {
            throw new Error(resp.resp);
        }
        this.bloqueado = resp.resp;
        if (!this.bloqueado) {
            filtros['id_sucursal'] = this.currentUser.sucursal.id;
            resp = await this.sucursalService.controlarBloqueo(filtros);
            if (!resp.ok) {
                throw new Error(resp.resp);
            }
            this.bloqueado = resp.resp;
        }
    }

    async cargarSucursalDelUsuario() {
        try {
            const filtros = [
                {
                    field: 'id_empresa',
                    value: this.currentUser.id_empresa,
                    type: 'id',
                },
                {
                    field: 'id',
                    value: this.currentUser.id_sucursal,
                    type: 'id',
                },
            ];
            const res = await this.sucursalService.getAll(Global.SIZE_GET_ALL, {
                filters: filtros,
            });
            if (res.ok) {
                this.sucursalObj = res.resp.rows[0];
            } else {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Sucursal no Encontrado',
                    detail: res.msg,
                });
            }
        } catch (error: any) {
            this.messageService.add({
                severity: 'error',
                summary: 'Error al cargar la sucursal',
                detail: error,
            });
            throw error;
        }
    }

    async verificarCajaBDWeb() {
        try {
            const registro = await this.indexDBService.getLastRecord(); //Verifico el ultimo registro
            if (registro) {
                this.registroDelDia = registro;
            }
        } catch (error: any) {
            this.messageService.add({
                severity: 'error',
                summary: 'Error al verificar la caja',
                detail: error,
            });
            throw error;
        }
    }

    async controlDeArqueoDeCaja() {
        try {
            const arqueoAbierto = await this.consultarArqueoAbierto();
            if (arqueoAbierto) {
                const hoy = this.datePipe.transform(
                    arqueoAbierto.hoy,
                    'yyyy-MM-dd'
                )!;
                const fecha_arqueo = this.datePipe.transform(
                    arqueoAbierto.fecha_transaccion,
                    'yyyy-MM-dd'
                )!;
                if (hoy > fecha_arqueo) {
                    this.cerrarCaja(
                        true,
                        'Arqueo Anterior',
                        `Debe cerrar su caja de fecha ${fecha_arqueo}`
                    );
                    return;
                }
                this.saldoInicial = arqueoAbierto.importe_apertura;
                this.cierre = true;
            } else {
                await this.recuperarCajas();
                this.aperturar = true;
            }
        } catch (error: any) {
            this.messageService.add({
                severity: 'error',
                summary: 'Error en el control de Arqueo',
                detail: error,
            });
            throw error;
        }
    }

    async consultarArqueoAbierto() {
        try {
            const filtros_arqueo = {
                id_empresa: this.currentUser.empresa.id,
                id_sucursal: this.currentUser.sucursal.id,
                id_usuario: this.currentUser.id,
                id_caja: this.registroDelDia.id_caja
                    ? this.registroDelDia.id_caja
                    : null,
            };
            const arqueoCaja = await this.arqueoService.consultarArqueo(
                filtros_arqueo
            );
            if (arqueoCaja.ok) {
                const arqueo = arqueoCaja.resp as Record<string, any>;
                return arqueo;
            } else {
                throw new Error('Arqueo no existe o aun falta por abrir');
            }
        } catch (error: any) {
            this.messageService.add({
                severity: 'info',
                summary: 'Arqueo no existe',
                detail: error,
            });
            return null;
        }
    }

    // recupera las cajas que estan disponibles
    async recuperarCajas() {
        try {
            const filtros = {
                id_empresa: this.currentUser.empresa.id,
                id_sucursal: this.currentUser.sucursal.id,
            };
            const resp = await this.cajaService.cajasDisponibles(filtros);
            if (!resp.ok) {
                throw new Error(resp.resp);
            }
            if (resp.ok) {
                this.cajas = resp.resp;
            }
        } catch (error: any) {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: error?.message,
            });
        }
    }

    async cajaSeleccionada(caja: Record<string, any>) {
        this.saldoInicial = 0;
        this.showImporteApertura = true;
        this.caja = caja;
    }

    async cancelarApertura() {
        this.caja = null;
        this.saldoInicial = 0;
        this.showImporteApertura = false;
        // this.router.navigate(Global.DASHBOARD);
    }

    async guardarDatos() {
        await this.crearArqueo();
        const registroCreado = await this.indexDBService.addRecord({
            id_caja: this.caja!.id,
        });
        this.registroDelDia = registroCreado;
        this.showImporteApertura = false;
        this.aperturar = false;
        this.cdr.detectChanges();
        await this.controlDeArqueoDeCaja();
    }

    async crearArqueo() {
        try {
            const objArqueo = await this.arqueoObjeto();
            await this.arqueoService.abrirArqueo(objArqueo);
        } catch (error: any) {
            this.messageService.add({
                severity: 'error',
                summary: 'Error al aperturar la caja',
                detail: error?.message,
            });
        }
    }

    async arqueoObjeto() {
        const objArqueo: Record<string, any> = {};
        objArqueo.importe_apertura = this.saldoInicial;
        objArqueo.id_caja = this.caja!.id;
        objArqueo.id_empresa = this.currentUser.empresa.id;
        objArqueo.id_sucursal = this.currentUser.sucursal.id;
        objArqueo.estado = ArqueoCaja.ESTADO_ABIERTO;
        objArqueo.id_creado_por = this.currentUser.id;
        return objArqueo;
    }

    async cerrarCaja(
        anterior = false,
        header = 'Cerrar Caja',
        message = 'Estas seguro/a de cerrar Caja?'
    ) {
        this.confirmationService.confirm({
            header: header,
            message: message,
            closeOnEscape: false,
            icon: 'pi pi-info-circle',
            acceptLabel: anterior ? 'Cerrar Arqueo' : 'Si, estoy seguro/a',
            acceptButtonStyleClass: 'p-button-success p-button-success',
            rejectButtonStyleClass: 'p-button-danger p-button-danger',
            accept: async () => {
                await this.actualizarArqueoYBaseDeDatosDelNavegador();
                await this.controlDeArqueoDeCaja();
            },
            reject: async () => {
                if (anterior) {
                    this.router.navigate(Global.DASHBOARD);
                }
            },
            rejectVisible: !anterior,
        });
    }

    async actualizarArqueoYBaseDeDatosDelNavegador() {
        const arqueoCaja = await this.consultarArqueoAbierto();
        this.objArqueo = {};
        if (arqueoCaja) {
            const caja = await this.recuperarCaja(arqueoCaja.id_caja);
            // //actualizar arqueo
            let objArqueo: Record<string, any> = {};
            objArqueo.id = arqueoCaja.id;
            objArqueo.id_empresa = this.currentUser.id_empresa;
            objArqueo.id_sucursal = this.currentUser.id_sucursal;
            objArqueo.id_caja = arqueoCaja.id_caja;
            const arqueoCerrado = await this.arqueoService.cerrarArqueo(
                objArqueo
            );
            //actualizar base de datos del navegador
            if (caja.tipo_impresora === Caja.TIPO_IMPRESORA_BLUETOOTH) {
                this.tipoImpresoraBluetooth = true;
            }
            await this.imprimirDocumentoArqueo(arqueoCerrado.resp);
            await this.indexDBService.clearStore('portal_pagos');
        } else {
            throw new Error('Arqueo no existe o ya se cerro');
        }
    }

    async datosAdicionales() {
        const datos: Record<string, any> = {
            usuario: this.currentUser,
            arqueo: await this.consultarArqueoAbierto(),
        };
        return datos;
    }

    async resetearValores() {
        // this.showPrintCobro = false;
        this.showModalServicio = false;
        this.showModalServicioPago = false;
        this.comercioSeleccionado = null;
        this.servicioSeleccionado = null;
        this.detalleServicioSeleccionado = null;
        this.campos = [];
        this.camposAdicionales = [];
        this.mostrarCamposAdicionales = false;
        this.fgCobro?.reset();
    }

    async cargarComercios() {
        try {
            await this.resetearValores();
            const resp = await this.homeService.comercios({});
            if (resp.ok) {
                this.comercios = resp.resp;
                await this.onFiltrarComercios();
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    async onBuscar(event: any) {
        if (event.key === 'Backspace') {
        }
        await this.onFiltrarComercios();
    }

    async onFiltrarComercios() {
        const value = this.formGroup.value;
        if (!value.buscar || String(value.buscar).length === 0) {
            this.comerciosFiltrados = this.comercios;
            return;
        }
        this.comerciosFiltrados = this.comercios.filter(
            (comercio: Record<string, any>) =>
                String(comercio.nombre)
                    .toLocaleUpperCase()
                    .includes(String(value.buscar).toUpperCase())
        );
    }

    async onComercio(comercio: Record<string, any>) {
        try {
            this.loading = true;
            const resp = await this.homeService.servicios({
                id_empresa: this.currentUser.id_empresa,
                ...comercio,
            });
            if (resp.ok) {
                this.servicios = resp.resp;
                this.comercioSeleccionado = comercio;
                this.showModalServicio = true;
                this.loading = false;
            }
        } catch (error: any) {
            console.log(`On Comercio ${error}`);
            this.messageService.add({
                severity: 'error',
                summary: '',
                detail: error.message,
            });
            this.loading = false;
        }
    }

    async onServicio(servicio: Record<string, any>) {
        try {
            this.loadingServicio = true;
            this.fgCobro = null;
            this.servicioSeleccionado = servicio;
            this.detalleServicioSeleccionado = null;
            const filtros = await this.obtenerFiltros(servicio);
            const resp = await this.apiService.procesarIntegracion(filtros);
            if (!resp.ok) {
                throw new Error(resp.resp);
            }
            await this.crearFormulario(resp.resp);
            this.loadingServicio = false;
            this.showBtns = true;
        } catch (error: any) {
            console.log(`On Servicio ${error}`);
            this.messageService.add({
                key: 'td',
                severity: 'error',
                summary: '',
                detail: error.message,
            });
            this.loadingServicio = false;
        }
    }

    /** Funcion para armar los filtros de acuerdo a la entidad */
    async obtenerFiltros(servicio: Record<string, any>) {
        if (servicio.codigo_entidad === Global.PRONET.codigo) {
            servicio['tipoTrx'] = Global.PRONET.parametros;
        }
        servicio['tipoTrx'] = Global.PRONET.parametros;
        return servicio;
    }

    /** Funcion para crear el formulario a mostar */
    async crearFormulario(servicio: Record<string, any>) {
        this.servicioSeleccionado = {
            ...this.servicioSeleccionado,
            ...servicio,
        };
        this.fgCobro = this.fb.group({
            mr_vuelto: [{ value: 0, disabled: true }, Validators.required],
            mr_importe_servicio: [
                { value: 0, disabled: true },
                Validators.required,
            ],
            mr_importe_cobrado: [0, Validators.required],
            mr_importe_recibido: [0, Validators.required],
        });
        const campos = servicio.campos as Record<string, any>[];
        this.campos = campos;
        await this.agregarCamposFormulario(campos);
    }

    // funcion para agregar campos al forumario en caso necesario
    async agregarCamposFormulario(
        campos: Record<string, any>[],
        controlarEditable: boolean = false
    ) {
        for (let index = 0; index < campos.length; index++) {
            const campo = campos[index];
            if (controlarEditable) {
                if (
                    String(campo[Global.CAMPOS.EDITABLE]) === Global.TRUE_STRING
                ) {
                    // Agregamos al formulario solo campos distintos a monto
                    if (
                        String(campo[Global.CAMPOS.TIPO]) !== 'AMOUNT' &&
                        String(campo[Global.CAMPOS.OCULTAR]) ===
                            Global.FALSE_STRING
                    ) {
                        let valor = campo[Global.CAMPOS.VALOR];
                        if (valor === '0') {
                            valor = null;
                        }
                        this.fgCobro?.addControl(
                            campo[Global.CAMPOS.NOMBRE],
                            new FormControl(valor)
                        );
                        this.camposAdicionales.push(campo);
                    }
                }
            } else {
                this.fgCobro?.addControl(
                    campo[Global.CAMPOS.NOMBRE],
                    new FormControl()
                );
            }
            // CAMPO REQUERIDO
            if (String(campo[Global.CAMPOS.REQUERIDO]) === Global.TRUE_STRING) {
                this.fgCobro
                    ?.get(campo[Global.CAMPOS.NOMBRE])
                    ?.setValidators([Validators.required]);
                this.fgCobro
                    ?.get(campo[Global.CAMPOS.NOMBRE])
                    ?.updateValueAndValidity();
            }
            // CAMPO EDITABLE
            if (String(campo[Global.CAMPOS.EDITABLE]) === Global.FALSE_STRING) {
                this.fgCobro?.get(campo[Global.CAMPOS.NOMBRE])?.disable();
                this.fgCobro
                    ?.get(campo[Global.CAMPOS.NOMBRE])
                    ?.updateValueAndValidity();
            }
        }
    }

    // 61966451
    async consultar() {
        try {
            this.loadingServicio = true;
            const fechaDataList = await this.obtenerFechaServicio();
            const formulario = JSON.parse(
                JSON.stringify(this.fgCobro?.getRawValue())
            );
            for (const fechaData of fechaDataList) {
                formulario[fechaData[Global.CAMPOS.NOMBRE]] =
                    this.datePipe.transform(
                        formulario[fechaData[Global.CAMPOS.NOMBRE]],
                        'ddMMyyyy'
                    );
            }
            const filtros = {
                ...this.servicioSeleccionado,
                formulario: formulario,
            };
            const resp = await this.apiService.procesarIntegracion(filtros);
            if (!resp.ok) {
                throw new Error(resp.resp);
            }
            if (resp.ok) {
                const consulta = resp.resp;
                this.servicioSeleccionado!['codServicio'] =
                    consulta['codServicio'];
                this.servicioSeleccionado!['tipoTrx'] = consulta['tipoTrx'];
                this.servicioSeleccionado!['campos'] = consulta['campos'];
                this.servicioSeleccionado!['detalles'] = consulta['detalles'];
                if (consulta?.respuestaConsulta) {
                    this.servicioSeleccionado!['respuestaConsulta'] =
                        consulta['respuestaConsulta'];
                }
                if (consulta?.referenciaConsulta) {
                    this.servicioSeleccionado!['referenciaConsulta'] =
                        consulta['referenciaConsulta'];
                }
                if (
                    (consulta['detalles'] as Record<string, any>[]).length > 0
                ) {
                    await this.agregarCamposFormulario(
                        consulta['detalles'][0],
                        true
                    );
                }
            }
            this.loadingServicio = false;
        } catch (error: any) {
            console.log(error);
            this.messageService.add({
                key: 'td',
                severity: 'error',
                summary: '',
                detail: error.message,
            });
            this.loadingServicio = false;
        }
    }

    async pagar() {
        // En caso de que sea un pago directo y que no se tenga que seleccionar lo que se va a pagarif ()
        if (!this.detalleServicioSeleccionado) {
            const detalles = [];
            for (const detalle of this.servicioSeleccionado?.campos) {
                detalle['valor'] = this.fgCobro?.get(detalle.nombre)?.value;
                detalles.push(detalle);
            }
            await this.onDetalleServicio(detalles);
        }
        const value = this.fgCobro?.getRawValue();
        if (value.mr_importe_recibido === 0) {
            this.messageService.add({
                key: 'td',
                severity: 'error',
                summary: 'Formulario Inválido',
                detail: 'Verifique que todo este bien cargado y/o haya seleccionado el item a cobrar',
            });
        } else {
            // verificamos si hay campos adicionales para actualizar en valor en servicioSeleccionado
            if (this.camposAdicionales.length > 0) {
                for (const campo of this.camposAdicionales) {
                    for (const detalle of this.detalleServicioSeleccionado!) {
                        if (detalle.nombre === campo.nombre) {
                            detalle.valor = this.fgCobro?.get(
                                campo.nombre
                            )?.value;
                            break;
                        }
                    }
                }
            }
            this.showModalServicioPago = true;
            this.showBtns = false;
        }
    }

    async calcularVuelto() {
        const value = this.fgCobro?.getRawValue();
        this.fgCobro?.get('mr_vuelto')?.setValue(0);
        if (
            Number(value.mr_importe_recibido) > Number(value.mr_importe_cobrado)
        ) {
            const vuelto =
                Number(value.mr_importe_recibido) -
                Number(value.mr_importe_cobrado);
            this.fgCobro?.get('mr_vuelto')?.setValue(vuelto);
        }
    }

    async cancelar() {
        await this.cargarComercios();
    }

    async onDetalleServicio(detalle: Record<string, any>[]) {
        this.detalleServicioSeleccionado = detalle;
        const importeData = await this.obtenerMonto();
        if (importeData) {
            this.fgCobro
                ?.get('mr_importe_servicio')
                ?.setValue(importeData[Global.CAMPOS.VALOR]);
            this.fgCobro
                ?.get('mr_importe_cobrado')
                ?.setValue(importeData[Global.CAMPOS.VALOR]);
            this.fgCobro
                ?.get('mr_importe_recibido')
                ?.setValue(importeData[Global.CAMPOS.VALOR]);
            if (
                String(importeData[Global.CAMPOS.EDITABLE]) ===
                Global.FALSE_STRING
            ) {
                this.fgCobro?.get('mr_importe_cobrado')?.disable();
                this.fgCobro
                    ?.get('mr_importe_cobrado')
                    ?.updateValueAndValidity();
            }
        }
        if (this.camposAdicionales.length > 0) {
            this.mostrarCamposAdicionales = true;
        }
    }

    async actualizarImporteCobrar() {
        const importeData = await this.obtenerMonto();
        if (importeData) {
            const value = this.fgCobro?.getRawValue();
            this.fgCobro
                ?.get(importeData[Global.CAMPOS.NOMBRE])
                ?.setValue(value['mr_importe_cobrado']);
            this.fgCobro
                ?.get('mr_importe_recibido')
                ?.setValue(value['mr_importe_cobrado']);
        }
    }

    private async obtenerMonto() {
        const importe = this.detalleServicioSeleccionado?.find(
            (detalle: Record<string, any>) =>
                String(detalle['debitable']) === Global.TRUE_STRING
        );
        return importe;
    }

    private async obtenerFechaServicio() {
        const fechas = this.campos?.filter(
            (campo: Record<string, any>) =>
                campo['tipo'] === 'DATE' &&
                String(campo['editable']) === Global.TRUE_STRING
        );
        return fechas;
    }

    async cancelarPago() {
        this.showModalServicioPago = false;
        this.showBtns = true;
    }

    async confirmarPago() {
        const processBlocked = await this.seguridadService.processIsBlocked();
        if (processBlocked) {
            return this.messageService.add({
                key: 'tr',
                severity: 'warn',
                summary: 'Cobro en proceso',
                detail: 'Ya existe un cobro en progreso, por favor espere un momento',
            });
        } else {
            const lockAcquired = await this.seguridadService.blockProcess();
            if (!lockAcquired)
                return this.messageService.add({
                    key: 'tr',
                    severity: 'warn',
                    summary: 'Cobro en proceso',
                    detail: 'Ya existe un cobro en progreso, por favor espere un momento',
                });
        }

        try {
            const value = this.fgCobro?.getRawValue();
            if (
                Number(value.mr_importe_recibido) <
                Number(value.mr_importe_cobrado)
            ) {
                this.fgCobro
                    ?.get('mr_importe_recibido')
                    ?.setValue(value.mr_importe_cobrado);
                return this.messageService.add({
                    key: 'tr',
                    severity: 'error',
                    summary: 'Cobro inválido',
                    detail: 'El importe recibido no puede ser menor al importe cobrado',
                });
            }
            this.loadingPagoServicio = true;
            this.objCobro = {}; // Inicializa como un objeto vacío
            const filtros = {
                formulario: this.fgCobro?.getRawValue(),
                servicio: this.servicioSeleccionado,
                detalleServicio: this.detalleServicioSeleccionado,
                datos: await this.datosAdicionales(),
                tipoTrx: this.servicioSeleccionado!['tipoTrx'],
                codigo_entidad: this.servicioSeleccionado!['codigo_entidad'],
            };
            const resp = await this.apiService.procesarIntegracion(filtros);
            if (!resp.ok) {
                throw new Error(resp.resp);
            }
            this.messageService.add({
                key: 'td',
                severity: 'success',
                summary: 'Pago Realizado Correctamente',
                detail: 'Preparando...',
            });
            this.loadingPagoServicio = false;
            setTimeout(async () => {
                await this.imprimirDocumentoCobro(resp.resp);
            }, 3000);
        } catch (error: any) {
            console.log(error);
            this.messageService.add({
                key: 'td',
                severity: 'error',
                summary: 'Error',
                detail: error.message,
            });
            this.showModalServicioPago = false;
            this.loadingPagoServicio = false;
            this.showBtns = true;
        } finally {
            await this.seguridadService.unblockProcess();
        }
    }

    override invalidControl(name: string) {
        return (
            this.fgCobro?.get(name)?.invalid && this.fgCobro?.get(name)?.touched
        );
    }

    mostrarBtnPago() {
        return (
            this.fgCobro?.valid &&
            this.servicioSeleccionado?.tipoTrx !== this.CONSULTA &&
            this.servicioSeleccionado?.tipoTrx !== this.CODIGO_BARRA
        );
    }

    servicioCardClass(detalle: Record<string, any>) {
        if (detalle === this.detalleServicioSeleccionado) {
            return 'card detalle-card detalle-card-selected';
        }
        return 'card detalle-card';
    }

    async actualizarFormulario(disable: boolean) {
        Object.keys(this.fgCobro?.controls!).forEach((key) => {
            if (disable) {
                this.fgCobro?.get(key)?.disable();
                this.fgCobro?.get(key)?.updateValueAndValidity();
            } else {
                this.fgCobro?.get(key)?.enable();
                this.fgCobro?.get(key)?.updateValueAndValidity();
            }
        });
    }

    async imprimirDocumentoArqueo(arqueoCerrado: Record<string, any>) {
        this.showPrintArqueo = true;
        this.objArqueo = {
            nombre_empresa: this.currentUser.empresa.nombre,
            nombre_sucursal: this.sucursalObj.nombre,
            direccion_sucursal: this.sucursalObj.direccion,
            nombre_cajero: this.currentUser.nombre,
            fecha_cierre: this.fecha_cierre,
            fecha_apertura: arqueoCerrado.fecha_creacion,
            nro_arqueo: arqueoCerrado.nro_transaccion,
            importe_apertura: arqueoCerrado.importe_apertura,
            total_ingreso: arqueoCerrado.total_ingreso,
            total_egreso: arqueoCerrado.total_egreso,
            cantidad_ingreso: arqueoCerrado.cantidad_ingreso,
            cantidad_egreso: arqueoCerrado.cantidad_egreso,
            fecha_impresion: new Date(),
            impreso: false,
        };
    }

    async imprimirDocumentoCobro(cobro: Record<string, any>) {
        this.showModalServicioPago = false;
        this.showModalServicio = false;
        const empresa = await this.empresaService.get(
            this.currentUser.id_empresa
        );
        if (!empresa.ok) {
            return this.messageService.add({
                severity: 'error',
                summary: 'Hubo un error vuelva a intentarlo',
                detail: empresa.msg,
            });
        }
        const infoCaja = await this.indexDBService.getLastRecord();
        const filtrosCaja = [
            {
                field: 'id_empresa',
                value: this.currentUser.id_empresa,
                type: 'id',
            },
            {
                field: 'id_sucursal',
                value: this.currentUser.id_sucursal,
                type: 'id',
            },
            { field: 'id', value: infoCaja.id_caja, type: 'id' },
        ];

        const respCaja = await this.cajaService.getAll(Global.SIZE_GET_ALL, {
            filters: filtrosCaja,
        });
        if (!respCaja.ok && respCaja.resp.count <= 0) {
            this.messageService.add({
                severity: 'info',
                summary: 'Caja no encontrada',
                detail: '',
            });
            return;
        }
        const caja = respCaja.resp.rows[0];
        if (caja.tipo_impresora === Caja.TIPO_IMPRESORA_BLUETOOTH) {
            this.tipoImpresoraBluetooth = true;
        }
        this.objCobro = {
            ...cobro,
            nombre_empresa: this.currentUser.empresa.nombre,
            direccion_empresa: empresa.resp.direccion,
            ruc_empresa: this.currentUser.empresa.nro_documento,
            nombre_sucursal: this.sucursalObj.nombre,
            direccion_sucursal: this.sucursalObj.direccion,
            nro_caja: caja.id,
            nombre_caja: caja.nombre,
            cajero: this.currentUser.codigo,
            estado_impresion: Cobro.ESTADO_IMPRESION_IMPRESO,
            fecha_impresion: new Date(),
        };
        this.showPrintCobro = true;
    }

    async actualizarCobroImpresion(cobro: Record<string, any>) {
        let objCobro: Record<string, any> = {};
        objCobro.id = cobro.id;
        objCobro.estado_impresion = Cobro.ESTADO_IMPRESION_IMPRESO;
        objCobro.id_empresa = cobro.id_empresa;
        objCobro.id_sucursal = cobro.id_sucursal;
        objCobro.id_actualizado_por = this.currentUser.id;
        objCobro.fecha_actualizacion = new Date();
        await this.cobroService.actualizarCobro(objCobro);
        await this.resetearValores();
    }

    async recuperarCaja(id_caja: number) {
        try {
            const filtros_caja = [
                {
                    field: 'id_empresa',
                    value: this.currentUser.empresa.id,
                    type: 'id',
                },
                {
                    field: 'id_sucursal',
                    value: this.currentUser.sucursal.id,
                    type: 'id',
                },
                { field: 'id', value: id_caja, type: 'id' },
            ];
            const caja = await this.cajaService.getAll(Global.SIZE_GET_ALL, {
                filters: filtros_caja,
            });
            if (caja.ok && caja.resp.count > 0) {
                return caja.resp.rows[0];
            } else {
                return this.messageService.add({
                    severity: 'info',
                    summary: 'Caja no disponible',
                    detail: `Cajas no encontradas`,
                });
            }
        } catch (error: any) {
            return this.messageService.add({
                severity: 'info',
                summary: 'Caja no disponible',
                detail: error,
            });
        }
    }

    obtenerFecha(valor: string) {
        const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
        if (dateRegex.test(valor)) {
            return valor;
        }

        const extendedDateRegex = /^\d{12}$/;
        if (extendedDateRegex.test(valor)) {
            const day = valor.slice(0, 2);
            const month = valor.slice(2, 4);
            const year = `20${valor.slice(4, 6)}`; // Convertir YY a YYYY
            return `${day}/${month}/${year}`;
        }

        const dataRegex2 = /^\d{2}\d{2}\d{4}/;
        const match = valor.match(dataRegex2);
        if (match?.length) {
            const fecha = match[0];
            const day = fecha.slice(0, 2);
            const month = fecha.slice(2, 4);
            const year = fecha.slice(4, 8);
            return `${day}/${month}/${year}`;
        }

        if (valor.length) {
            const day = valor.slice(0, 2);
            const month = valor.slice(2, 4);
            const year = valor.slice(4, 6);
            return `${day}/${month}/${year}`;
        }
        return valor;
    }
}
